var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"header_button",on:{"click":function($event){return _vm.onClickMenu()}}},[_c('img',{attrs:{"src":(_vm.cdn + "/img/top/icon_humberger.svg"),"alt":"メニュー"}})])}
var staticRenderFns = []

export { render, staticRenderFns }